import { createSecretKey } from "@core/foundation/token";
import type { z } from "@core/zod";

import { KEY_PREFIX } from "./key-prefix.ts";

export const {
  generateKey: generateMemoryApiKey,
  keySchema: MemoryApiKeySchema,
  verifyKey: verifyMemoryApiKey,
} = createSecretKey({ keyPrefix: KEY_PREFIX.MEMORY_API });

export type MemoryApiKey = z.infer<typeof MemoryApiKeySchema>;
